import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { ShareTrackData } from '../../types';
import { ShareTrackRepository } from '../share-tools-repository';
import type { ShareTrackService } from '../share-track-service';

@injectable()
export class ShareTrackServiceImpl implements ShareTrackService {
    constructor(
        @inject(ShareTrackRepository) private shareTrackRepository: ShareTrackRepository
    ) {
    }

    trackShare(data: ShareTrackData) {
        return this.shareTrackRepository.trackShare({
            event_type: 'SS Share Info',
            ...data,
        });
    }
}
